/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Console_Copy_InterfaceInputs */

const en_console_copy_interface = /** @type {(inputs: Console_Copy_InterfaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy interface`)
};

const zh_hans1_console_copy_interface = /** @type {(inputs: Console_Copy_InterfaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制类型定义`)
};

const pt_br2_console_copy_interface = /** @type {(inputs: Console_Copy_InterfaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar interface`)
};

const es_console_copy_interface = /** @type {(inputs: Console_Copy_InterfaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar interfaz`)
};

const fr_console_copy_interface = /** @type {(inputs: Console_Copy_InterfaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier l’interface`)
};

const de_console_copy_interface = /** @type {(inputs: Console_Copy_InterfaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interface kopieren`)
};

const ru_console_copy_interface = /** @type {(inputs: Console_Copy_InterfaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать интерфейс`)
};

const it_console_copy_interface = /** @type {(inputs: Console_Copy_InterfaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia interfaccia`)
};

/**
* | output |
* | --- |
* | "Copy interface" |
*
* @param {Console_Copy_InterfaceInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const console_copy_interface = /** @type {((inputs?: Console_Copy_InterfaceInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Console_Copy_InterfaceInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_console_copy_interface(inputs)
	if (locale === "pt-BR") return pt_br2_console_copy_interface(inputs)
	if (locale === "es") return es_console_copy_interface(inputs)
	if (locale === "fr") return fr_console_copy_interface(inputs)
	if (locale === "de") return de_console_copy_interface(inputs)
	if (locale === "ru") return ru_console_copy_interface(inputs)
	if (locale === "it") return it_console_copy_interface(inputs)
	return en_console_copy_interface(inputs)
});